export default __webpack_public_path__ + "static/media/BootsSharp-Regular1.ede6e1d8.svg";